/**
 * Plugin de inicialización
 *
 * Lee las cookies de autenticación y restaura la sesión al iniciar la app.
 * El prefijo "0." asegura que se ejecute primero.
 */
export default defineNuxtPlugin(async () => {
    const authStore = useAuthStore()
    const configStore = useConfigStore()
    const categoryStore = useCompanyCategoryStore()

    const accessTokenCookie = useCookie('accessToken')
    const refreshTokenCookie = useCookie('refreshToken')

    // Si hay tokens en cookies, restaurar sesión
    if (accessTokenCookie.value || refreshTokenCookie.value) {
        // La restauración es todo-o-nada: cualquier fallo (sesión caducada,
        // red caída) lleva a login con la sesión limpia
        try {
            await authStore.restoreSession({
                accessToken: accessTokenCookie.value,
                refreshToken: refreshTokenCookie.value
            })
        } catch (error) {
            console.error('[init] No se pudo restaurar la sesión:', error)
            authStore.clearAuth()
            configStore.clearConfig()
            return navigateTo('/login')
        }

        // La config pública tiene defaults en el store: un fallo no es fatal
        // para la sesión, solo se opera sin config remota
        try {
            await configStore.loadConfig()
        } catch (error) {
            console.error('[init] No se pudo cargar la configuración:', error)
        }

        if (authStore.isAuthenticated) {
            // W10: si los permisos no cargan, la habilidad CASL queda vacía y
            // todas las rutas con meta `permission` redirigen a /forbidden sin
            // ninguna explicación. Mejor cerrar sesión y volver a login.
            try {
                await authStore.loadPermissions()
            } catch (error) {
                console.error('[init] No se pudieron cargar los permisos:', error)
                authStore.clearAuth()
                configStore.clearConfig()
                return navigateTo('/login')
            }

            // Las categorías tienen fallback en el store: no son críticas
            try {
                await categoryStore.loadCategories()
            } catch (error) {
                console.error('[init] No se pudieron cargar las categorías de empresa:', error)
            }
        }
    }
})
